import React from "react";
import { RenterArchiveTable } from "./overview/RenterArchiveTable";
import { OverviewContainer } from "../../common/OverviewContainer";

export function RenterArchiveOverview() {
  return (
    <OverviewContainer title={null}>
      <RenterArchiveTable />
    </OverviewContainer>
  );
}
